/** Wires react-router into the library's NavProvider, so library pieces (Link, useParam, ErrorBoundary) follow the app's router. */
import { useMemo, type ReactNode } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { NavProvider, type Nav } from '../ui/nav'

export function RouterNav({ children }: { children: ReactNode }) {
  const loc = useLocation()
  const go = useNavigate()
  const value = useMemo<Nav>(() => ({ where: { pathname: loc.pathname, search: loc.search }, navigate: (to, opts) => void go(to, { replace: opts?.replace }) }), [loc.pathname, loc.search, go])
  return <NavProvider value={value}>{children}</NavProvider>
}
